/* eslint-disable sonarjs/no-duplicate-string */
import app from 'Cloud/Application/app';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { sendAgreement } from 'reactApp/appHelpers/appHelpers';
import { renderLicenseAgreementDialog } from 'reactApp/components/LicenseAgreement/licenseAgreement.toolkit';
import { IWelcomeAttachesRepeatingProps } from 'reactApp/components/WelcomeAttaches/WelcomeAttachesRepeating';
import {
    renderWelcomeAttachesDialogHelper,
    renderWelcomeDialogHelper,
    renderWelcomeDialogNewHelper,
    renderWelcomeRepeatingAttachesDialogHelper,
} from 'reactApp/components/WelcomeDialog/welcomeDialogToolkit';
import { EAuthDwhAction } from 'reactApp/modules/dwh/dwh.types';
import { isDefaultRootContent } from 'reactApp/modules/home/home.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { showUploaderAction } from 'reactApp/modules/upload/upload.module';
import { store as reduxStore } from 'reactApp/store';
import { sendXray } from 'reactApp/utils/ga';
import { goToNewDocumentIfCan } from 'reactApp/utils/goToNewDocumentIfCan';
import { noopVoid } from 'reactApp/utils/helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { sendAuthDwhRequest } from '../dwh/dwh.module';
import { EnvironmentSelectors } from '../environment/environment';
import { getFeatureAbMailAttachesAfterClose } from '../features/features.selectors';

export const isWelcomePromo = () =>
    app?.isHome() && app.getState && app.getState().id === '/' && isDefaultRootContent(reduxStore.getState());

const showUploader = () => reduxStore.dispatch(showUploaderAction());

const groupAb = getFeature('ab-trial-popup');

const sendFirstEnter = () =>
    sendPaymentGa({
        eventCategory: ECategoryGa.onboarding,
        action: 'first-enter',
        label: '',
        group: groupAb || 'None',
    });

let dialog;
export const renderWelcomeHelper = ({
    storage,
    onSuccess = noopVoid,
    publishMode = false,
    onClose = noopVoid,
}: {
    storage: EStorageType;
    onSuccess?();
    onClose?();
    publishMode?: boolean;
}) => {
    // tempexp_14505-start
    const state = reduxStore.getState();
    const abMailAttachesAfterClose = getFeatureAbMailAttachesAfterClose(state);
    // tempexp_14505-end

    const isPhone = EnvironmentSelectors.isPhone();
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const onAccept = () => {
        sendFirstEnter();
        showUploader();

        goToNewDocumentIfCan(state);
    };

    // tempexp_14505-next-line
    if (storage === EStorageType.attaches && abMailAttachesAfterClose !== 'b') {
        dialog = renderWelcomeAttachesDialogHelper({
            publishMode,
            onSuccess: () => {
                sendAgreement('mail_');
                sendXray('ui_welcome_start-mail');
                if (dialog) {
                    dialog.close();
                    dialog = null;
                }
                onSuccess();
                onAccept();
                reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseAccept, source: 'attaches' }));
            },
            onShow: () => reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseOpen, source: 'attaches' })),
        });

        return;
    }

    if (isPhone) {
        renderLicenseAgreementDialog({
            closable: false,
            onSuccess: () => {
                onAccept();
                reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseAccept, source: 'none' }));
            },
        });

        return;
    }

    // tempexp_14505-start
    if (abMailAttachesAfterClose === 'b') {
        renderWelcomeDialogNewHelper({
            onSuccess: () => {
                sendAgreement();
                onAccept();
                onClose();
                reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseAccept, source: 'none' }));
            },
            onShow: () => {
                reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseOpen, source: 'none' }));
            },
        });
    } else {
        // tempexp_14505-end
        renderWelcomeDialogHelper({
            onComplete: showUploader,
            // eslint-disable-next-line sonarjs/no-identical-functions
            onClose: () => {
                sendAgreement();
                onAccept();
                onClose();
                reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseAccept, source: 'none' }));
            },
            onShow: () => reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseOpen, source: 'none' })),
        });
    }
};

export const isWelcomeDialogShown = (): boolean => !!dialog;

export interface WelcomeRepeatingHelperHandler {
    (data: { storage: EStorageType }): void;
}
const ATTACHES_REPEATING_RADAR = 'repeat_welcome_attaches';

export const renderWelcomeRepeatingHelper: WelcomeRepeatingHelperHandler = ({ storage }) => {
    if (storage !== EStorageType.attaches || isWelcomeDialogShown()) {
        return;
    }
    const params: IWelcomeAttachesRepeatingProps = {
        onClose: () => {
            sendXray(ATTACHES_REPEATING_RADAR, {
                show: 1,
            });
            dialog = null;
        },
        onAccept: () => {
            sendXray(ATTACHES_REPEATING_RADAR, {
                accept: 1,
            });
            dialog?.close?.();
        },
        onShow: () => {
            sendXray(ATTACHES_REPEATING_RADAR, {
                show: 1,
            });
        },
    };
    dialog = renderWelcomeRepeatingAttachesDialogHelper(params);
};
